import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ApiRequestStatus } from '@makemydeal/dr-shared-types';

import { requestProposalSelectors } from '../store';
import { getDealProposal } from '../store/multi-scenario/actionCreators';
import { getDealProposalFetchStatus } from '../store/multi-scenario/selectors';

export const useDealProposal = () => {
    const dispatch = useDispatch();
    const fetchStatus = useSelector(getDealProposalFetchStatus);
    const publishedVersion = useSelector(requestProposalSelectors.additionalSelectors.getPublishedVersion);

    useEffect(() => {
        if (publishedVersion && fetchStatus === ApiRequestStatus.Idle) {
            dispatch(getDealProposal());
        }
    }, [dispatch, fetchStatus, publishedVersion]);

    return { isLoading: fetchStatus === ApiRequestStatus.Loading };
};
